export default {
  "b2b.zadosti-odsouhlasene-widget.label": "Approved requests",
  "b2b.zadosti-odsouhlasene-widget.message-empty": "No approved requests."
};
